import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/metronic/core/_base/layout/services/translation.service';
import { HomePageService } from '../home-page/home-page.service';
import { AlertData } from '../home-page/models/alert.model';

@Component({
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss', '../home.component.scss']
})
export class ContactPageComponent implements OnInit {
  alerts: AlertData[] = [];

  constructor(
    private service: HomePageService,
    private translationService: TranslationService
  ) { }

  get isPolishSelected(): boolean{
    return this.translationService.isPolishLanguageSelected();
  }
  ngOnInit() {
    this.getActiveAlerts();
  }


  private getActiveAlerts(): void {
    this.service
      .getActiveAlerts(this.translationService.getCurrentLanguage())
      .subscribe(a => this.alerts = a);
  }
}
